// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"277":"88526a586078e9a2","362":"6447b654aca988a1","488":"3d74646f5a16d9af","564":"287754d6d83ca064"}[chunkId] + ".js";
};